module.exports = __webpack_public_path__ + "static/media/img_template.39ae1455.png";